import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Changepassword from "pages/Authentication/Changepassword";
import UserProfile from "pages/Authentication/UserProfile";
import DrugList from "pages/Dashboard/Drugs/DrugList";
import DrugAdd from "pages/Dashboard/Drugs/DrugAdd";
import DrugEdit from "pages/Dashboard/Drugs/DrugEdit";
import UserList from "pages/Dashboard/Users/UserList";
import UserAdd from "pages/Dashboard/Users/UserAdd";
import UserEdit from "pages/Dashboard/Users/UserEdit";
import AssignedDrugsUser from "pages/Dashboard/Users/AssigneDrugsUser";
import UserDashboard from "pages/UserDashboard/Dashboard/UserDashboard";
import AssignDrugList from "pages/UserDashboard/Pages/AssignDrugList";
import AssignDrugListOption from "pages/UserDashboard/Pages/AssignDrugListOption";
import Notifications from "pages/Dashboard/notifications";
 
  
const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: <Dashboard /> },
  { path: "/change-password", exact: true, component: <Changepassword /> },
  { path: "/user-profile", exact: true, component: <UserProfile /> },
  { path: "/drug-list", exact: true, component: <DrugList /> },
  { path: "/drug-add", exact: true, component: <DrugAdd /> },
  { path: "/drug-edit/:id", exact: true, component: <DrugEdit /> },
  { path: "/user-list", exact: true, component: <UserList /> },
  { path: "/user-add", exact: true, component: <UserAdd /> },
  { path: "/user-edit/:id", exact: true, component: <UserEdit /> },
  { path: "/assigne-drug/:id", exact: true, component: <AssignedDrugsUser /> },
  { path: "/notifications-list", exact: true, component: <Notifications /> },
  { path: "/user-list/:inactive", exact: true, component: <UserList /> },
  {
    path: "/dashboard",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const authProtectedRoutesUser = [
  { path: "/dashboard", exact: true, component: <UserDashboard /> },
  { path: "/change-password", exact: true, component: <Changepassword /> },
  { path: "/user-profile", exact: true, component: <UserProfile /> },
  { path: "/assgined-user-drug-list", exact: true, component: <AssignDrugList /> },
  { path: "/assgined-user-drug-form/:id", exact: true, component: <AssignDrugListOption /> },
  { path: "/notifications-list", exact: true, component: <Notifications /> },
   
  {
    path: "/dashboard",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // ...(Infuseonerolename === '' ? [
  { path: "/", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  // ] : []),
];

export { authProtectedRoutes, publicRoutes, authProtectedRoutesUser };
